<template>
  <div class="contact">
  <div class="details container">
    <h1 class='title'>Contact</h1>
    <div class="columns is-multiline">
          <div v-show="school === 'stjustins'" class="column">
            <p class="subtitle">
      <a :href="stjustinsEnrol"><strong>Enrol online right now!</strong></a></p>
       <!-- <div class="subtitle is-4"><p>St Justin's </p></div> -->
      <p class="subtitle">
        <!-- <span class="icon"><i class="fas fa-phone"></i></span>  -->
        <strong>Phone:</strong>
        <a :href="'tel:'+stjustinsPhone">{{stjustinsPhone}}</a> </p><p class="subtitle">
          <!-- <span class="icon"><i class="fas fa-envelope"></i></span>  -->
          <strong>Email:</strong>
          <a :href="'mailto:'+stjustinsEmail">{{stjustinsEmail}}</a>
      </p>
      </div>
    <div v-show="school === 'stgregs'" class="column">
       <p class="subtitle">
      <a :href="stgregsEnrol"><strong>Enrol online right now!</strong></a></p>
       <!-- <div class="subtitle is-4"><p>St Gregory's</p></div> -->
      <p class="subtitle">
        <!-- <span class="icon"><i class="fas fa-phone"></i></span>  -->
        <strong>Phone:</strong>
      <a :href="'tel:'+stgregsPhone">{{stgregsPhone}}</a> </p><p class="subtitle">
        <!-- <span class="icon"><i class="fas fa-envelope"></i></span>  -->
        <strong>Email:</strong>
      <a :href="'mailto:'+stgregsEmail">{{stgregsEmail}}</a></p>
     </div>
      <div v-show="school === 'maryimmaculate'" class="column">
       <!-- <div class="subtitle is-4"><p>St Gregory's</p></div> -->
      <p class="subtitle">
         <router-link :class="{'is-dark is-orange is-large button': false }" to="/enrol">
          How to Enrol
        </router-link>
        <a :href="maryImmaculateEnrol" :class="{'is-dark is-orange is-large button': false }"><strong>Enrol online  right now</strong> </a>
      </p>
        <p class="subtitle">
        <!-- <span class="icon"><i class="fas fa-phone"></i></span>  -->
        <strong>Phone:</strong>
      <a :href="'tel:'+maryImmaculatePhone">{{maryImmaculatePhone}}</a> </p><p class="subtitle">
        <!-- <span class="icon"><i class="fas fa-envelope"></i></span>  -->
        <strong>Email:</strong>
      <a :href="'mailto:'+maryImmaculateEmail">{{maryImmaculateEmail}}</a></p>
     </div>
     <div class="column is-12">
             <a @click="showForm" href="#" loading="loaded" v-scroll-to="{ el:'#contactForm', duration: 300, easing: 'ease-in-out', offset: 0 }" :class="{'is-dark is-orange is-medium button': false, 'is-loading': !loaded }" inverted>Or click here to fill out our contact form</a></div>
      </div>

  </div>
    <iframe id='contactForm' v-show="show" @load="loadForm" src="https://docs.google.com/forms/d/e/1FAIpQLSf-TIDEH76uj5Xt6WSOh1Xqpl5XfoHbVldbhIjnexQIbbChSw/viewform?embedded=true" width="100%" height="1300px" frameborder="0" marginheight="0" marginwidth="0">Loading...</iframe>
  </div>
</template>

<script>
export default {
  name: 'Contact',
  props: ['school'],
  data () {
    return {
      stjustinsPhone: '0425 213 083',
      stgregsPhone: '0467 866 256',
      maryImmaculatePhone: '0409 960 803',
      stjustinsEmail: 'stjustins@ooshzone.com.au',
      stgregsEmail: 'stgregs@ooshzone.com.au',
      maryImmaculateEmail: 'miev@ooshzone.com.au',
      stjustinsEnrol: 'https://app.kidsoft.com.au/p/ooshzoneStJustins/find-a-place',
      stgregsEnrol: 'https://app.kidsoft.com.au/p/ooshzoneStGreg/find-a-place',
      maryImmaculateEnrol: 'https://app.kidsoft.com.au/p/ooshzonemaryimmaculate/find-a-place',
      loaded: false,
      show: false
    }
  },
  methods: {
    loadForm: function () {
      this.loaded = true
    },
    showForm: function () {
      this.show = true
    }
  }
}
</script>

<style scoped>
.contact {
  margin-bottom: -10px;
}
.details {
  padding: 60px;
  padding-bottom: 20px;
}
.is-dark:hover {
  color: #e67e22;
}
a {
  color: #e67e22;
  text-align: left;
}
a:hover {
  color: #e67d22b6;
}
.is-orange{
  white-space: normal;
  padding: 30px 15px;
}
@media screen and (max-width: 480px) {
  .is-orange{
    padding: 50px 15px;
  }
}
.icon {
  vertical-align:middle;
}
p {
  text-align: left;
}
@media screen and (min-width: 900px) {
.column {
  text-align: left;
  padding: 30px 120px;
  font-size: 1.25rem;
}
}
 p.subtitle a strong {
  text-transform: uppercase;
  border-bottom: 2px solid;
  text-align: center;
}
p.subtitle a strong:hover {
  color: #e67d22b6;
}
.column.is-12 {
  padding-top: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/Contact.vue